import { useMemo } from "react";
import { createContext, useContext } from "react";

type TwilioContextType = {
  twilioToken: string | null;
  twilio: any;
};

const TwilioContext = createContext<TwilioContextType>({
  twilioToken: null,
  twilio: null
});

const twilioClientMock: any = null;
const twilioTokenMock: any = null;

export const TwilioContextProvider = ({ children }: any) => {
  const contextValue = useMemo(() => {
    return {
      twilio: twilioClientMock,
      twilioToken: twilioTokenMock
    };
  }, []);

  return (
    <TwilioContext.Provider value={contextValue}>
      {children}
    </TwilioContext.Provider>
  );
};

export const useTwilioContext = () => {
  const context = useContext(TwilioContext);
  if (!context) {
    throw new Error(
      `useTwilioContext must be used within a TwilioContextProvider`
    );
  }
  return context;
};
